module.exports = __webpack_public_path__ + "images/favicon-5a32a4e66119d23ddacf4573bac91591.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/favicons/favicon.jpg
// module id = 16
// module chunks = 0